<template>
    <InformeCard id="resumen" name="resumen" collapsable="true" title="Resúmenes" class="text-center">
        <h4 class="text-center">
            Destacamos datos que te pueden servir de ayuda para que incentives los medios de promoción de tu evento:
        </h4>

        <hr/>

        <div>
            <ResumenCardComponent title="Venta de Entradas">
                <template v-slot:textoVentas>
                    <span>
                        <b>Total de ventas online:</b> {{ totalVentasOnline }}
                    </span>

                    <br/>

                    <span>
                        <b>Total de ventas en taquila:</b> {{ totalVentasTaquilla }}
                    </span>
                </template>

                <template v-slot:content>
                    <b-card-text v-if="totalVentasTaquilla > totalVentasOnline">
                        <b>Visualiza en tus medios digitales la facilidad al usuario de adquirir entradas cómodamente
                            sin desplazarse online</b>. Recuerda las grandes ventajas al usuario y optimización de
                        recursos que repercuten los gastos que suponen habilitar puntos físicos.
                    </b-card-text>

                    <b-card-text v-if="totalVentasOnline > totalVentasTaquilla">
                        <b>Estas haciendo un gran trabajo en la venta online</b>, queda mucho por
                        mejorar pero es un camino importante para lograr los objetivos deseados.
                    </b-card-text>

                    <b-card-text v-if="totalVentasOnline == totalVentasTaquilla">
                        <b>No hay un predominio de venta online sobre la física</b>, debes aumentar tus medios de
                        promoción en el Marketing Online
                    </b-card-text>
                </template>
            </ResumenCardComponent>

            <ResumenCardComponent title="Edad de los Usuarios">
                <template v-slot:content>
                    <b-card-text v-if="franjaEdadesPredominante[2] != 0">
                        El usuario que predomina en tus ventas es en la franja de edad
                        <span v-if="franjaEdadesPredominante.length == 1">
                            <b>{{ franjaEdadesPredominante[0] }}</b>
                        </span>

                        <span v-else v-for="edades in franjaEdadesPredominante" :key="edades.id">
                            <b>{{ edades }}</b>
                        </span>,
                        esto es muy importante en la optimización de los recursos de promoción, teniendo en cuenta a
                        que público objetivo quieres dirigirte y los medios de promoción a utilizar.
                    </b-card-text>
                </template>
            </ResumenCardComponent>

            <ResumenCardComponent title="Género de los Usuarios">
                <template v-slot:content>
                    <b-card-text v-if="generoPredominante[2] != 0">
                        En tus ventas predominan

                        <span v-if="generoPredominante.length == 1 && generoPredominante[0] == 'Hombre'">
                            los <b>Hombres</b>
                        </span>

                        <span v-else-if="generoPredominante.length == 1 && generoPredominante[0] == 'Mujer'">
                            las <b>Mujeres</b>
                        </span>

                        <span v-else-if="generoPredominante.length == 1 && generoPredominante[0] == 'Otro'">
                            <b>otro tipo de géneros</b>
                        </span>

                        <span v-else v-for="generos in generoPredominante" :key="generos.id">
                            <b>{{ generos }}</b>
                        </span>, un dato muy importante a la hora de realizar promociones y dirigirte al público deseado
                        y utilizar el género más interesante para lograr tus objetivos.
                    </b-card-text>
                </template>
            </ResumenCardComponent>

            <ResumenCardComponent title="Horas Calientes">
                <template v-slot:content>
                    <b-card-text v-if="horaPredominante[2] != 0">
                        Hay que destacar que la hora más caliente es
                        <span v-if="horaPredominante.length == 1 && horaPredominante[0] == 1">
                            <b>a la 1 de la mañana</b>
                        </span>

                        <span v-else-if="horaPredominante.length == 1 && horaPredominante[0] < 12">
                            a las <b>{{ horaPredominante[0] }}</b> AM
                        </span>

                        <span v-else-if="horaPredominante.length == 1 && horaPredominante[0] >= 12">
                            a las <b>{{ horaPredominante[0] }}</b> PM
                        </span>

                        <span v-else v-for="horas in horaPredominante" :key="horas.id">
                            <b>{{ horas }}</b>
                        </span>.
                        Es cuando el usuario esté adquiriendo el mayor número de entradas del evento,
                        te recomendamos utilizar las redes sociales en esta franja horaria. Así como, twitter, Instagram,
                        tiktok... realizando una publicación que te ayude a superar las ventas en la hora caliente de tu
                        evento.
                    </b-card-text>
                </template>
            </ResumenCardComponent>

            <ResumenCardComponent title="Procedencia de los Usuarios">
                <template v-slot:content>
                    <b-card-text v-if="provinciaPredominante.length != 0 || provinciaPredominante[0] != ''">
                        El mayor número de usuarios proviene de
                        <span v-if="provinciaPredominante.length == 1">
                            <b>{{ provinciaPredominante[0] }}</b>
                        </span>

                        <span v-else-if="provinciaPredominante.length > 1"
                              v-for="provincia in provinciaPredominante" :key="provincia.id"
                        >
                            {{ provincia }}
                        </span>

                        <span v-if="cpPredominante[0] != null">
                            con código postal <b>{{ cpPredominante[0] }}</b>
                        </span>

                        <span v-else>
                            sin código postal registrado
                        </span>. Es importante si utilizas medios físicos de
                        promoción además de inversiones en publicidad en redes sociales, potenciando la ubicación de los
                        mismos, sacando a su vez conclusiones de porqué el usuario predomina en esta localidad o distrito de
                        la ciudad como una fuente de grandes ventas.
                    </b-card-text>
                </template>
            </ResumenCardComponent>
        </div>

        <hr/>

        <h3>
            Esperamos haberte ayudado, pronto ampliaremos características de este apartado para que
            tu evento sea todo un éxito ❤️
        </h3>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";
    import ResumenCardComponent from "./components/ResumenCardComponent.vue";

    export default {
        props: [
            'totalVentasOnline',
            'totalVentasTaquilla',
            'totalEdades',
            'totalGeneros',
            'totalHorasVentas',
            'totalEntradasProvincia',
            'totalEntradasCP'
        ],

        components: {
            InformeCard,
            ResumenCardComponent
        },

        data() {
            return {
                franjaEdadesPredominante: [],
                generoPredominante: [],
                horaPredominante: [],
                provinciaPredominante: [],
                cpPredominante: [],
            }
        },

        methods: {
            getEdadesPredominantes() {
                let maxCount = 0;
                let maxCountRanges = [];
                let minAge = Infinity;
                let maxAge = 0;

                for (let i = 1; i < this.totalEdades.length; i++) {
                    const range = this.totalEdades[i][0];
                    const count = this.totalEdades[i][1];

                    if (count > maxCount) {
                        maxCount = count;
                        maxCountRanges = [range];

                        const ages = range.split("-");
                        minAge = parseInt(ages[0]);
                        maxAge = parseInt(ages[1]);
                    } else if (count == maxCount) {
                        maxCountRanges.push(range);

                        const ages = range.split("-");
                        const thisMinAge = parseInt(ages[0]);
                        const thisMaxAge = parseInt(ages[1]);

                        if (thisMinAge < minAge) {
                            minAge = thisMinAge;
                        }

                        if (thisMaxAge > maxAge) {
                            maxAge = thisMaxAge;
                        }
                    }
                }

                if (maxCountRanges.length == 1) {
                    this.franjaEdadesPredominante = maxCountRanges;
                } else {
                    this.franjaEdadesPredominante.push(minAge);
                    this.franjaEdadesPredominante.push('-');
                    this.franjaEdadesPredominante.push(maxAge);
                }
            },

            getGeneroPredominante() {
                let maxCount = 0;
                let maxCountRanges = [];
                let minGen = Infinity;
                let maxGen = 0;

                for (let i = 1; i < this.totalGeneros.length; i++) {
                    const range = this.totalGeneros[i][0];
                    const count = this.totalGeneros[i][1];

                    if (count > maxCount) {
                        maxCount = count;
                        maxCountRanges = [range];

                        const gens = range.split("-");
                        minGen = parseInt(gens[0]);
                        maxGen = parseInt(gens[1]);
                    } else if (count == maxCount) {
                        maxCountRanges.push(range);

                        const gens = range.split("-");
                        const thisMinGen = parseInt(gens[0]);
                        const thisMaxGen = parseInt(gens[1]);

                        if (thisMinGen < minGen) {
                            minGen = thisMinGen;
                        }

                        if (thisMaxGen > maxGen) {
                            maxGen = thisMaxGen;
                        }
                    }
                }

                if (maxCountRanges.length == 1) {
                    this.generoPredominante = maxCountRanges;
                } else {
                    this.generoPredominante.push(minGen);
                    this.generoPredominante.push(' y ');
                    this.generoPredominante.push(maxGen);
                }
            },

            getHoraPredominante() {
                let maxCount = 0;
                let maxHours = [];

                for (let i = 1; i < this.totalHorasVentas.length; i++) {
                    const hour = this.totalHorasVentas[i][0];
                    const count = this.totalHorasVentas[i][1];

                    if (count > maxCount) {
                        maxCount = count;
                        maxHours = [hour];
                    } else if (count == maxCount) {
                        maxHours.push(', ');
                        maxHours.push(hour);
                    }
                }

                if (maxHours.length == 1) {
                    this.horaPredominante = maxHours;
                } else {
                    this.horaPredominante = maxHours;
                }
            },

            getProvinciaCPPredominante() {
                let mayorTotal = 0;
                let ubicacionesMayoresTotales = [];

                for (let i = 0; i < this.totalEntradasCP.length; i++) {
                    const ubicacion = this.totalEntradasCP[i];
                    const total = parseInt(ubicacion.total);

                    if (total > mayorTotal) {
                        mayorTotal = total;
                        ubicacionesMayoresTotales = [ubicacion];
                    } else if (total == mayorTotal) {
                        ubicacionesMayoresTotales.push(ubicacion)
                    }
                }

                for (let i = 0; i < ubicacionesMayoresTotales.length; i++) {
                    const ubicacion = ubicacionesMayoresTotales[i];

                    this.cpPredominante = [ubicacion.cp];
                    this.provinciaPredominante = [ubicacion.provincia_nombre];
                }
            }
        },

        created() {
            this.getEdadesPredominantes();
            this.getGeneroPredominante();
            this.getHoraPredominante();
            this.getProvinciaCPPredominante();
        },
    }
</script>